import React from 'react';
import styles from '../PasswordProtectionUnlock.module.scss';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
  EButtonStyle,
} from '@/components/common/Button/Button';

interface IUnlockActionsProps {
  readonly onCancelClick: () => void;
  readonly onUnlockClick: () => void;
}

export const UnlockActions: React.FC<IUnlockActionsProps> = ({
  onCancelClick,
  onUnlockClick,
}) => {
  return (
    <div className={styles.unlockButtons}>
      <Button
        onClick={onCancelClick}
        hierarchy={EButtonHierarchy.primary}
        buttonStyle={EButtonStyle.tonal}
        fillWidth={true}
        size={EButtonSize.lg}
        text="blockPage.unlock.cancel"
      />
      <Button
        onClick={onUnlockClick}
        hierarchy={EButtonHierarchy.primary}
        fillWidth={true}
        size={EButtonSize.lg}
        text="blockPage.unlock.unlock"
      />
    </div>
  );
};
